<div class="main">

    <div class="error-icon">
        <!-- <app-svg-icon [path]="'assets/icons/error_icon.svg'"></app-svg-icon> -->
        <img src="assets/icons/error_icon.svg"/>
    </div>

    <div class="error-msg">
        <div class="error-msg-header">
            @if (errorLogs.length > 0) {
                <span>IRN Generation Failed</span>
            } @else {
            <span>IRN Generation is pending</span>
            }
        </div>
        <div class="error-msg-body">
            @if (errorLogs.length > 0) {
                <span>
                    The IRN generation for the selected invoice has failed. Please check the error logs for more details.   
                </span>
            } @else {
                <span>
                    IRN generation for the selected invoice is currently pending. If the delay persists, you may retry the operation.
                </span>
            }
        </div>
        <div class="retry-action" *ngIf="enableRetry">
            <button class="retry-button" (click)="retryIrnGeneration()">
                <span>Retry Invoice generation</span>
            </button>
        </div>
    </div>

    <div class="error-log-container" *ngIf="errorLogs.length > 0">
        <div class="error-log-header">
            <app-svg-icon [path]="'assets/icons/error_icon_vec.svg'"></app-svg-icon>
            <span>Error Log:</span>
        </div>
        <div class="divider"></div>
        <div class="error-log-body">
            <li class="error-log-item" *ngFor="let error of errorLogs">
                <span>{{ error }}</span>
            </li>
        </div>
    </div>
</div>